import { EventNotesStyles } from './EventNotes.types'

const makeStyles = (): EventNotesStyles => ({
	eventNoteContainer: {
		marginTop: '5px'
	},
	note: {
		fontFamily: 'SVFont',
		fontSize: '24px',
		margin: '0px'
	}
})

export default makeStyles
